import { alcoholApi } from "@api";
// import { updateSnackBar } from "@redux";
import moment from "moment";
import React, { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
import { AppExportCsv, CircularLoader } from "../Common";
import { StyledAlcoholTable } from "./style";
import { Avatar, Grid2 } from "@mui/material";
import { linkAvatar, theme } from "@utils";

interface IState {
  date: any;
}

const AlcoholCheckedTable = (props: IState) => {
  const { date } = props;
  // const [selectedIds, setSelectedIds] = useState<{ [key: number]: boolean }>({});
  const [loading, setLoading] = React.useState<boolean>();
  const [idChecker, setIdChecker] = useState<any>();
  // const [data, setData] = useState<any>();
  const [dataConfirmHistory, setDataConfirmHistory] = useState<any>();

  const [csvStartDate, setCsvStartDate] = React.useState<string>(moment(new Date).format("YYYY-MM-DD"));
  const [csvEndDate, setCsvEndDate] = React.useState<string>(moment(new Date).format("YYYY-MM-DD"));

  // const dispatch = useDispatch();

  useEffect(() => {

    const getListAlcoholConfirmHistory = async () => {
      setLoading(true);
      try {
        const res = await alcoholApi.getAlcoholInformationHistory({
          date: moment(date).format("YYYY-MM-DD"),
        });
        setLoading(false);
        setDataConfirmHistory(res.data.data);
      } catch (error: any) {
        setLoading(false);
      }
    };

    getListAlcoholConfirmHistory();
    if (idChecker) {

      getListAlcoholConfirmHistory();
    }
  }, [date, idChecker]);
  return (
    <StyledAlcoholTable>
      <CircularLoader loading={loading} />

      <div className="al-table">
        <Grid2 container>
          <Grid2 size={{ xs: 12 }}>
            <div className="subTitle">
              <Grid2 container spacing={1}>
                <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 2, xl: 2 }}>名前</Grid2>
                <Grid2 size={{ xs: 4, sm: 4, md: 4, lg: 1, xl: 1 }}>チェック者</Grid2>
                <Grid2 size={{ xs: 4, sm: 4, md: 4, lg: 1, xl: 1 }}>運転者</Grid2>
                <Grid2 size={{ xs: 4, sm: 4, md: 4, lg: 2, xl: 2 }}>車両名</Grid2>
                <Grid2 size={{ xs: 4, sm: 4, md: 4, lg: 2, xl: 2 }}>チェック製品</Grid2>
                <Grid2 size={{ xs: 4, sm: 4, md: 4, lg: 1, xl: 1 }}>出勤/退勤</Grid2>
                <Grid2 size={{ xs: 4, sm: 4, md: 4, lg: 1, xl: 1 }}>数値</Grid2>
                <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 2, xl: 2 }}>管理者確認</Grid2>
              </Grid2>
            </div>
          </Grid2>


          <Grid2 size={{ xs: 12 }}>
            <div className="al-content">
              {dataConfirmHistory && dataConfirmHistory.length > 0 ? (
                dataConfirmHistory?.map((item, index) => (
                  <Grid2
                    container
                    spacing={1}
                    key={item.id}
                    sx={{
                      borderBottom: index === dataConfirmHistory.length - 1 ? "none" : `1px solid ${theme.colors.lightgray09}`,
                      paddingBottom: 1,
                      alignItems: "center"
                    }}
                  >
                    <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 2, xl: 2 }}>
                      <div className="userContainer">
                        <Avatar src={linkAvatar(item?.avatar)} />
                        <p>{item.employee_name}</p>
                      </div>
                    </Grid2>

                    <Grid2 size={{ xs: 4, sm: 4, md: 4, lg: 1, xl: 1 }}>
                      <div className="recordName">
                        <p className="recordName__text">チェック者</p>
                      </div>
                      <p>{item.inspector}</p>
                    </Grid2>

                    <Grid2 size={{ xs: 4, sm: 4, md: 4, lg: 1, xl: 1 }}>
                      <div className="recordName">
                        <p className="recordName__text">運転者</p>
                      </div>
                      <p>{item.driver}</p>
                    </Grid2>

                    <Grid2 size={{ xs: 4, sm: 4, md: 4, lg: 2, xl: 2 }}>
                      <div className="recordName">
                        <p className="recordName__text">車両名</p>
                      </div>
                      <p>{item.vehicle}</p>
                    </Grid2>

                    <Grid2 size={{ xs: 4, sm: 4, md: 4, lg: 2, xl: 2 }}>
                      <div className="recordName">
                        <p className="recordName__text">チェック製品</p>
                      </div>
                      <p>{item.device_check}</p>
                    </Grid2>

                    <Grid2 size={{ xs: 4, sm: 4, md: 4, lg: 1, xl: 1 }}>
                      <div className="recordName">
                        <p className="recordName__text">出勤/退勤</p>
                      </div>
                      <div>
                        <p>{item.start_time_check_alcohol.slice(0, 5)}</p>
                        <p>{item.end_time_check_alcohol.slice(0, 5)}</p>
                      </div>
                    </Grid2>

                    <Grid2 size={{ xs: 4, sm: 4, md: 4, lg: 1, xl: 1 }}>
                      <div className="recordName">
                        <p className="recordName__text">数値</p>
                      </div>
                      <div>
                        <p>{item.start_capacity_alcohol} mg</p>
                        <p>{item.end_capacity_alcohol} mg</p>
                      </div>
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 2, xl: 2 }}>
                      <div className="recordName">
                        <p className="recordName__text">管理者確認</p>
                      </div>
                      <div>{item.alcohol_checker}</div>
                    </Grid2>
                  </Grid2>
                ))
              ) : (
                <p style={{ textAlign: "center" }}>
                  アルコール濃度に関するデータはありません
                </p>
              )}
            </div>
          </Grid2>
        </Grid2>
      </div>

      <div className="csvExportDiv">
        <span className="csvExportTitle">CSVエクスポート</span>
        <div className="tsDatePicker">

          <div className="dateContainer">

            <div className="label">作成日時</div>
            <div className="dateSubContainer">
              <input type="date" className="inputDate"
                value={csvStartDate}
                onChange={(e) => setCsvStartDate(e.target.value)}
              />
              <span>から</span>
            </div>

            <div className="dateSubContainer">
              <input type="date" className="inputDate"
                value={csvEndDate}
                onChange={(e) => setCsvEndDate(e.target.value)}
              />
              <span>まで</span>
            </div>
          </div>

          <div>
            <AppExportCsv type={"alcohol-check"}
              startDate={csvStartDate} endDate={csvEndDate}
            />
          </div>

        </div>

      </div>

    </StyledAlcoholTable>
  );
};

export default AlcoholCheckedTable;
